import React from 'react';
import { formatCurrency } from '../../utils/calculations';
interface TotalsPanelProps {
  subtotal: number;
  taxAmount: number;
  taxRate: number;
  shippingCharge?: number;
  discount?: number;
  total: number;
}
export function TotalsPanel({
  subtotal,
  taxAmount,
  taxRate,
  shippingCharge = 0,
  discount = 0,
  total
}: TotalsPanelProps) {
  return <div className="bg-gray-50 rounded-lg p-4 space-y-2" data-id="element-139">
      <div className="flex justify-between text-sm" data-id="element-140">
        <span className="text-gray-600" data-id="element-141">Subtotal</span>
        <span className="font-medium text-gray-900" data-id="element-142">
          {formatCurrency(subtotal)}
        </span>
      </div>

      {shippingCharge > 0 && <div className="flex justify-between text-sm" data-id="element-143">
          <span className="text-gray-600" data-id="element-144">Shipping</span>
          <span className="font-medium text-gray-900" data-id="element-145">
            {formatCurrency(shippingCharge)}
          </span>
        </div>}

      <div className="flex justify-between text-sm" data-id="element-146">
        <span className="text-gray-600" data-id="element-147">
          Tax ({(taxRate * 100).toFixed(0)}%)
        </span>
        <span className="font-medium text-gray-900" data-id="element-148">
          {formatCurrency(taxAmount)}
        </span>
      </div>

      {discount > 0 && <div className="flex justify-between text-sm" data-id="element-149">
          <span className="text-gray-600" data-id="element-150">Discount</span>
          <span className="font-medium text-green-600" data-id="element-151">
            -{formatCurrency(discount)}
          </span>
        </div>}

      <div className="border-t border-gray-200 pt-2 mt-2" data-id="element-152">
        <div className="flex justify-between" data-id="element-153">
          <span className="text-base font-semibold text-gray-900" data-id="element-154">Total</span>
          <span className="text-base font-bold text-gray-900" data-id="element-155">
            {formatCurrency(total)}
          </span>
        </div>
      </div>
    </div>;
}